import React from "react";

import { st, FormMessage, FormControl, ProductVariantFullDecorator, ProductPricelistItemDecorator } from "lib/index";
import ProductPricelistItemFormSection from "./ProductPricelistItemFormSection";

export default class ProductVariantPricelistFormSection extends React.PureComponent {
  state = {
    newProductPricelistItem: ProductPricelistItemDecorator.build({ _new: true }),
  };

  handleProductVariantPropChange(prop, value) {
    const { product_variant, product_price_currency, onChange } = this.props;

    if (prop === "pricelist_type") {
      if (
        (value === "pricelist_by_item" || value === "pricelist_by_order") &&
        !product_variant.product_pricelist_items.find((ppi) => ppi.pricelist_type === value)
      ) {
        const preset = ProductPricelistItemDecorator.presets.find((preset) => preset.pricelist_type === value);
        const newProductPricelistItem = ProductPricelistItemDecorator.build({
          preset_id: preset.preset_id,
          price: null,
        });
        const nextProductVariant = new ProductVariantFullDecorator({
          ...product_variant,
          [prop]: value,
          product_pricelist_items: product_variant.product_pricelist_items.concat([newProductPricelistItem]),
        });
        return onChange(nextProductVariant);
      }
    }

    onChange(
      new ProductVariantFullDecorator({
        ...product_variant,
        [prop]: value,
      })
    );
  }

  handleProductPricelistItemAdd(attributes = {}) {
    const { product_variant, product_price_currency, onChange } = this.props;
    const preset = ProductPricelistItemDecorator.presets.find((preset) => preset.preset_id === attributes.preset_id);
    const newProductPricelistItem = ProductPricelistItemDecorator.build({
      _focus: true,
      preset_id: preset.preset_id,
      price: null,
      ...attributes,
      ...(preset.default_attributes || {}),
    });
    const product_pricelist_items = product_variant.product_pricelist_items.concat([newProductPricelistItem]);
    onChange({
      ...product_variant,
      product_pricelist_items: this.normalizeProductPricelistItems(product_pricelist_items),
    });
  }

  handleProductPricelistItemChange(nextProductPricelistItem) {
    const { product_variant, product_price_currency, onProductPriceCurrencyChange, onChange } = this.props;

    if (nextProductPricelistItem._new) {
      this.setState({ newProductPricelistItem: ProductPricelistItemDecorator.build({ _new: true }) });
      this.handleProductPricelistItemAdd({ ...nextProductPricelistItem, _new: undefined });
    } else if (
      nextProductPricelistItem.price &&
      nextProductPricelistItem.price.currency &&
      nextProductPricelistItem.price.currency !== product_price_currency
    ) {
      onProductPriceCurrencyChange(nextProductPricelistItem.price.currency);
    } else {
      const product_pricelist_items = product_variant.product_pricelist_items.map((x) =>
        x.uuid === nextProductPricelistItem.uuid ? { ...nextProductPricelistItem, _focus: undefined } : x
      );
      onChange({
        ...product_variant,
        product_pricelist_items: this.normalizeProductPricelistItems(product_pricelist_items),
      });
    }
  }

  handleProductPricelistItemRemove(product_pricelist_item) {
    const { product_variant, onChange, onBlur } = this.props;
    const product_pricelist_items = product_variant.product_pricelist_items.filter(
      (x) => x.uuid !== product_pricelist_item.uuid
    );
    onChange({
      ...product_variant,
      product_pricelist_items: this.normalizeProductPricelistItems(product_pricelist_items),
    });
    onBlur();
  }

  componentDidMount() {
    console.log(this.props.product.has_pricing);
    console.log(this.props.product.pricelist_type);
    console.log(this.props.product_variant.pricelist_type);
    console.log(this.props.product.booking_type);
    console.log(this.props.product.product_type);

    if (this.props.product.has_pricing && !this.props.product_variant.pricelist_type) {
      if (this.props.product.product_type === "standard") {
        this.handleProductVariantPropChange("pricelist_type", "pricelist_by_person");
      }
      if (this.props.product.product_type === "ticket") {
        this.handleProductVariantPropChange("pricelist_type", "pricelist_by_person");
      }
      if (this.props.product.product_type === "voucher") {
        this.handleProductVariantPropChange("pricelist_type", "pricelist_by_order");
      }
    }
  }

  normalizeProductPricelistItems(items) {
    return items.map((item, i) => ({
      ...item,
      position: i + 1,
    }));
  }

  render() {
    const { readOnlyAccess, product, product_variant, product_price_currency, errors, name, onBlur, onChange } =
      this.props;
    const { newProductPricelistItem } = this.state;
    return (
      <div>
        {!!errors[name] && <FormMessage error={errors[name]} />}

        {product.has_pricing && (
          <div>
            <FormControl.MultipleRadioFormGroup
              {...FormControl.addProps(`${name}.pricelist_type`, { errors })}
              value={product_variant.pricelist_type}
              onBlur={onBlur}
              onChange={this.handleProductVariantPropChange.bind(this, "pricelist_type")}
              label={I18n.humanAttributeName("product_variant", "pricelist_type")}
              required
              options={ProductVariantFullDecorator.pricelist_types}
              inline
              inlineLabel
              readOnly={readOnlyAccess}
            />

            {!!errors[`${name}.product_pricelist_items`] && (
              <FormMessage error={errors[`${name}.product_pricelist_items`]} />
            )}

            {!!product_variant.pricelist_type && (
              <div className="fields grouped">
                {product_variant.current_product_pricelist_items
                  .concat(
                    readOnlyAccess || product_variant.pricelist_type === "pricelist_by_order"
                      ? []
                      : [newProductPricelistItem]
                  )
                  .map((product_pricelist_item, i) => (
                    <ProductPricelistItemFormSection
                      key={product_pricelist_item.uuid}
                      readOnlyAccess={readOnlyAccess}
                      name={`${name}.product_pricelist_items[${product_pricelist_item.uuid}]`}
                      product_pricelist_item={product_pricelist_item}
                      errors={errors}
                      onBlur={onBlur}
                      onChange={this.handleProductPricelistItemChange.bind(this)}
                      onRemove={this.handleProductPricelistItemRemove.bind(this, product_pricelist_item)}
                      pricelist_type={product_variant.pricelist_type}
                      isFirstItem={i === 0}
                      product={product}
                      product_price_currency={product_price_currency}
                      editedLocale={this.props.editedLocale}
                    />
                  ))}
              </div>
            )}
          </div>
        )}

        {product.product_type === "coupon" && (
          <div>
            <FormControl.MoneyFormGroup
              {...FormControl.addProps(`${name}.coupon_offer_price_before_discount`, { errors })}
              label={I18n.humanAttributeName("product_variant", "coupon_offer_price_before_discount")}
              inlineLabel
              value={product_variant.coupon_offer_price_before_discount}
              onBlur={onBlur}
              onChange={(v) => {
                if (v && v.currency !== product_price_currency) {
                  this.props.onProductPriceCurrencyChange(v.currency);
                } else {
                  this.handleProductVariantPropChange("coupon_offer_price_before_discount", v);
                }
              }}
              readOnly={readOnlyAccess}
              defaultCurrency={product_price_currency}
              min={0}
            />

            <FormControl.FormGroup inline label={I18n.humanAttributeName("product_variant", "coupon_discount_amount")}>
              <FormControl.Money
                value={product_variant.coupon_discount_amount_or_percentage}
                onBlur={onBlur}
                onChange={(v) => {
                  if (v && v.currency !== "percentage" && v.currency !== product_price_currency) {
                    this.props.onProductPriceCurrencyChange(v.currency);
                  } else {
                    this.handleProductVariantPropChange("coupon_discount_amount_or_percentage", v);
                  }
                }}
                readOnly={readOnlyAccess}
                defaultCurrency={product_price_currency}
                withPercentageCurrency
                min={0}
              />
            </FormControl.FormGroup>

            <FormControl.MoneyFormGroup
              {...FormControl.addProps(`${name}.coupon_offer_price`, { errors })}
              label={I18n.humanAttributeName("product_variant", "coupon_offer_price")}
              inlineLabel
              value={product_variant.coupon_offer_price}
              onBlur={onBlur}
              onChange={(v) => {
                if (v && v.currency !== product_price_currency) {
                  this.props.onProductPriceCurrencyChange(v.currency);
                } else {
                  this.handleProductVariantPropChange("coupon_offer_price", v);
                }
              }}
              readOnly={readOnlyAccess || !product_variant.coupon_discount_amount_or_percentage}
              defaultCurrency={product_price_currency}
              min={0}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepPricelist/ProductVariantPricelistFormSection.jsx